import { Type } from "./types";

export const ALL_ACCESS_TYPES: readonly Type[] = [
  "all_access",
  "all_access_v2",
  "all_access_v3",
  "all_access_v4",
];
export const CURRENT_ALL_ACCESS_TYPE: Type = "all_access_v3";

export const isAllAccessType = (type: string): boolean =>
  ALL_ACCESS_TYPES.includes(type as Type);

export const ALL_ACCESS_PRICE_MAP: Record<string, number> = {
  all_access: 89.99,
  all_access_v2: 159.99,
  all_access_v3: 299.99,
  all_access_v4: 499.99,
};

export const ALL_ACCESS_PRICE_LABEL_MAP: Record<string, string> = {
  all_access: "$89.99/mo",
  all_access_v2: "$159.99/mo",
  all_access_v3: "$299.99/mo",
  all_access_v4: "$499.99/mo",
};

export const ALL_ACCESS_DISPLAY_PRICE = "$299.99";
